'use client';

import Image from "next/image";
import Button from "../ui/Button";
import Link from "next/link";

type CtaBannerSectionProps = {
  heading?: string;
  description?: string;
  ctaText?: string;
  ctaHref?: string;
  ariaLabel?: string;
};

export default function CtaBannerSection({
  heading = "Dank dispensary in Calgary, Alberta",
  description =
  "Easily buy your favorite strains, concentrates, edibles, or vape pens online and come pick them up for a faster\ncheck out experience. We will text when your order is ready for pickup. We strive to be the best cannabis\ndispensary in Canada and will not disappoint!",
  ctaText = "Order & Pickup",
  ctaHref = "/search",
  ariaLabel = "Order and Pickup CTA",
}: CtaBannerSectionProps = {}) {
  return (
    <section
      className="px-4 sm:px-6 lg:px-8"
      aria-label={ariaLabel}
    >
      <div className="relative w-full rounded-2xl overflow-hidden bg-[#FFD2D2] max-sm:min-h-[580px]">
        <div className="absolute inset-0">
          <Image
            src="/media/pages/home/cta/banner-shopping-background-shape.webp"
            alt="CTA Banner Shopping Background Shape"
            className="absolute object-cover top-0 left-1/2 translate-x-[-50%] max-sm:hidden"
            priority={false}
            loading="lazy"
            width={1147}
            height={415}
          />
          <Image
            src="/media/pages/home/cta/banner-shopping-background-shape-mobile.webp"
            alt="CTA Banner Shopping Background Shape"
            className="absolute object-cover top-0 left-1/2 translate-x-[-50%] sm:hidden"
            priority={false}
            loading="lazy"
            width={1147}
            height={415}
          />
        </div>

        <div className="absolute inset-0 h-full">
          <Image
            src="/media/pages/home/cta/banner-shopping.webp"
            alt=""
            className="absolute object-cover top-0 right-0 w-auto h-auto max-sm:hidden min-h-full"
            priority={false}
            loading="lazy"
            quality={60}
            sizes="(max-width: 640px) 0px, 520px"
            width={520}
            height={477}
          />
          <Image
            src="/media/pages/home/cta/banner-shopping-mobile.webp"
            alt=""
            className="absolute object-cover right-0 h-auto sm:hidden w-full bottom-0"
            priority={false}
            loading="lazy"
            quality={60}
            sizes="(max-width: 640px) 100vw, 0px"
            width={520}
            height={477}
          />
        </div>

        <div className="relative z-10 flex flex-col lg:flex-row items-center">
          <div className="flex-1 px-6 lg:px-12 py-8 lg:py-12 flex flex-col justify-center">
            <h2 className="sm:text-h3-desktop text-h3-mobile font-bold text-text-primary mb-4 lg:mb-6 leading-tight">
              {heading}
            </h2>
            <p className="sm:text-body-md text-body-14-mobile text-text-secondary mb-6 lg:mb-8 leading-relaxed max-w-2xl opacity-95">
              {description.split("\n").map((line, idx) => (
                <span key={idx}>
                  {line}
                  {idx < description.split("\n").length - 1 ? <br /> : null}
                </span>
              ))}
            </p>
            <Button asChild variant="primary" size="lg" className="rounded-xl px-6 py-3 w-fit">
              <Link href={ctaHref}>
                {ctaText}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

